import { Injectable, inject } from '@angular/core';
import { NavigationBar } from '@capgo/capacitor-navigation-bar';
import { ColorCalculationsService, ColorStyle } from '@libs/core/color';

@Injectable()
export class NavigationBarService {
  private colorCalculationsService = inject(ColorCalculationsService);

  async setBackgroundColor(color: string): Promise<void> {
    const darkButtons = this.colorCalculationsService.getStyleFromBackground(color) === ColorStyle.Dark;

    await NavigationBar.setNavigationBarColor({
      color,
      darkButtons,
    });
  }

  hide() {
    return NavigationBar.setNavigationBarColor({
      color: 'transparent',
      darkButtons: false,
    });
  }
}
